import { useParams, useNavigate } from 'react-router-dom';
import { Stack, IconButton, Typography, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CalendarFrame from '../../components/calendar/CalendarFrame';

export default function RequestCalendarPage() {
  const { requestKey } = useParams<{ requestKey: string }>();
  const navigate = useNavigate();

  if (!requestKey) {
    return (
      <Paper sx={{ m: 3, p: 4 }}>
        <Typography>Request not found</Typography>
      </Paper>
    );
  }

  return (
    <Stack sx={{ height: '100%' }}>
      <Stack direction="row" alignItems="center" p={2} spacing={1}>
        <IconButton onClick={() => navigate(`/request/${requestKey}`)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6">Request Calendar</Typography>
      </Stack>
      <CalendarFrame
        associatedType="request"
        associatedUuid={requestKey}
        showChrome={true}
        backTo={`/request/${requestKey}`}
      />
    </Stack>
  );
}
